import React, { useState, useEffect, useMemo } from 'react'
import CAMHeader from "../../../components/Header/CAMHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import TabsNav from "../common/ProcessNav";
import { Box } from "@mui/material";
import MultipleInput from "../../../components/Card/MultipleInput";
import Table from "./Table"
import Pagination from '../../../components/Pagination/index';
import Loader from '../../../components/Loader/loader';
import SnackBar from '../../../components/Snackbars/CustomizedSnackbars';
import AddProduct from './AddUop';
import BatchFilterPopup from "../../investigationAnalysis/review/BatchFilterPopup";
import { useDispatch, useSelector } from "react-redux";
import * as uop from "../../../redux/uop/actions";
import ConfirmationDialog from '../../../components/DialogBox/Confirmation';
import debounce from "lodash.debounce";
import { formatLocal } from '../../../utility';
import { fetchProductsSitesAndUnitOfOperations } from "../../../redux/visualization/actions";
import { hasPermission } from "../../../utils/permissions";
import {
  CONFIGURATION_PERMISSIONS,
  PERMISSION_MODULES,
} from "../../../constants/permissions";

const UopList = () => {
    const canAddUop = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.ADD_UNIT_OPERATION);
    const canUpdateUop = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.UPDATE_UNIT_OPERATION);
    const canApproveUop = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.APPROVE_UNIT_OPERATION);

    const [page, setPage] = useState(1);
    const [filterOpen, setFilterOpen] = useState(false);
    const [openDailog, setOpenDailog] = useState(false);
    const [openConfirmDailog, setOpenConfirmDailog] = useState(false);
    const userName = localStorage.getItem('userName');
    const [formData, setFormData] = useState({
        step_name: '',
        site_id: '',
        product_id: '',
        user: userName
    });
    const [snack, setSnack] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const [openProduct, setOpenProduct] = useState(false);
    const [selectedRow, setSelectedRow] = useState();
    const rowsPerPage = 50;
    const [addErrors, setAddErrors] = useState();
    const dispatch = useDispatch();
    const rowData = useSelector((state) => state?.uop);
    const [debouncedSearch, setDebouncedSearch] = useState();
    const [search, setSearch] = useState();
    const [filters, setFilters] = useState({
        from_date: "",
        to_date: "",
    });

    const handleReset = () => {
        setFilters({
            from_date: "",
            to_date: "",
        });
    }

    const handlePageChange = (event, value) => {
        setPage(value);
        getUopListCall(value)
    };

    const handleChange = (field, value) => {
        setFilters((prev) => ({ ...prev, [field]: value }));
    };

    const debouncedSetValue = useMemo(
        () =>
            debounce((val) => {
                setDebouncedSearch(val);
            }, 700),
        []
    );

    const handleSearch = (e) => {
        setSearch(e.target.value);
        debouncedSetValue(e.target.value);
    };

    const validateAddErrors = (isRequired) => {
        setAddErrors({});
        const newErrors = {};
        if (!formData.step_name) {
            newErrors.step_name = "Required";
        } else {
            const regex = /[\/\\:*?"<>|\[\]]/;

            if (regex.test(formData.step_name)) {
                newErrors.step_name =
                    "Special characters are not allowed";
            }
        }
        if (!formData.product_id) newErrors.product_id = "Required";
        if (!formData.site_id) newErrors.site_id = "Required";
        setAddErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        let newValue;
        if (typeof value === "string") {
            newValue = value?.trim() === "" ? null : value;
        } else {
            newValue = value === "" ? null : value;
        }
        setFormData((prev) => ({ ...prev, [name]: newValue }));
    }

    const handleAddSubmit = async (e) => {
        e.preventDefault();
        if ((selectedRow && !canUpdateUop) || (!selectedRow && !canAddUop)) return;
        if (!validateAddErrors(false)) return;
        if (selectedRow) {
            try {
                const res = await dispatch(uop.UpdateUop(formData));
                setSnack({
                    open: true,
                    message: res.data.message || "Updated successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenProduct(false)
                getUopListCall(page)
            } catch (error) {
                setSnack({
                    open: true,
                    message: error.response?.data?.error || "Something went wrong",
                    severity: "error"
                });
            }
        } else {
            try {
                const res = await dispatch(uop.AddUop(formData));
                setSnack({
                    open: true,
                    message: res.data.message || "Added successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenProduct(false)
                getUopListCall(page)

            } catch (error) {
                setSnack({
                    open: true,
                    message: error.response?.data?.error || "Something went wrong",
                    severity: "error"
                });
            }
        }
    };

    const getUopListCall = (page) => {
        const data = {
            page: page,
            page_size: rowsPerPage
        }
        if (search) data.search = debouncedSearch;
        if (filters.from_date) data.from_date = formatLocal(filters.from_date);
        if (filters.to_date) data.to_date = formatLocal(filters.to_date);
        dispatch(uop.getUopList(data))
    }

    useEffect(() => {
        setPage(1)
        getUopListCall(1)
    }, [debouncedSearch])

    useEffect(() => {
        dispatch(uop.getUopMeta())
    }, [])

    const handleDelete = async () => {
        try {
            const res = await dispatch(uop.DeleteUop({ unit_op_id: selectedRow.unit_op_id, user: userName }));
            setSnack({
                open: true,
                message: res.data.message || "Deleted successfully",
                severity: "success"
            });
            setOpenDailog(false);
            getUopListCall(page)

        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.message || "Something went wrong",
                severity: "error"
            });
        }

    }

    const handleUpdate = () => {

    }

    const handleGenerate = () => {
        getUopListCall(1)
    }
    const handleAddUop = () => {
        if (!canAddUop) return;
        setAddErrors({});
        setOpenProduct(true)
        setFormData({
            step_name: '',
            site_id: '',
            product_id: '',
            user: userName
        })
        setSelectedRow('')
    }

    const handleMenuOption = (option, row) => {
        if (!canUpdateUop) return;
        setSelectedRow(row)
        if (option === 'Delete') {
            setOpenDailog(true);
        } else {
            setAddErrors({});
            setFormData({
                unit_op_id: row.unit_op_id,
                step_name: row.step_name,
                site_id: row.site_id,
                product_id: row.product_id,
                user: userName
            })
            setOpenProduct(true)
        }
    }

    const handleApprove = async () => {
        if (!canApproveUop || !selectedRow?.unit_op_id) return;
        try {
            const res = await dispatch(uop.ApproveUop({ unit_op_id: selectedRow.unit_op_id, user: userName }));
            setSnack({
                open: true,
                message: res.data.message || "Approved successfully",
                severity: "success"
            });
            setOpenConfirmDailog(false);
            getUopListCall(page)
            dispatch(fetchProductsSitesAndUnitOfOperations(true));

        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.error || "Something went wrong",
                severity: "error"
            });
        }
    }

    const handleUopApprove = (row) => {
        if (!canApproveUop) return;
        setSelectedRow(row)
        setOpenConfirmDailog(true)
    }
    return (
        <> <CAMHeader />
            <CAMDrawer />
            <InvestigatorContainer>  <TabsNav />

                <Box sx={{ borderTop: "1px solid #e0e0e0" }}>
                    <MultipleInput
                        text={'Unit Operation List'}
                        buttonText={"Add Unit Operation"}
                        popupFilter={true}
                        onButtonClick={handleAddUop}
                        placeholder={"Search by UOP name"}
                        // handleChildClick={handleChildClick}
                        // handleClick={handleClick}
                        // handleMenuOptionCallBack={handleMenuOptionCallBack}
                        // filterOptionsGroup1={group1}
                        // filterOptionsGroup2={group2}
                        // selectedFilters={selectedFilters}
                        // handleCheckboxChange={handleCheckboxChange}
                        isButton={canAddUop}
                        // isAuditLogs={true}
                        handleSearch={handleSearch}
                        search={search}
                        // viewAuditLogs={viewAuditLogs}
                        // auditText={"Audit Trail"}
                        // viewLogs={viewLogs}
                        // popupFilter={true}
                        handlePopupFilter={() => setFilterOpen(true)}
                        // onBackClick={() => setViewLogs(false)}
                        isFillterIcon={false}
                    />
                </Box>
                {snack?.open && (
                    <SnackBar
                        className="popup"
                        handleClose={() => {
                            setSnack({
                                open: false,
                                message: "",
                                severity: "",
                            });
                        }}
                        severity={snack.severity}
                        state={snack?.open}
                        text={snack?.message}
                    />
                )}
                <Box>
                    <AddProduct
                        open={openProduct}
                        formData={formData}
                        onChange={handleOnChange}
                        onClose={() => {
                            setAddErrors({});
                            setOpenProduct(false);
                        }}
                        errors={addErrors}
                        handleSubmit={handleAddSubmit}
                        dropdownOption={rowData}
                    // setFieldType={handleSetFieldType}
                    // fieldType={fieldType}
                    // sepcificaitonForm={sepcificaitonForm}
                    // handleAcceptanceValueChange={handleAcceptanceValueChange}
                    // handleDeleteAcceptanceValue={handleDeleteAcceptanceValue}
                    // handleAddAcceptanceValue={handleAddAcceptanceValue}
                    // handleBlockChange={handleBlockChange}
                    // handleAddBlock={handleAddBlock}
                    // handleDeleteBlock={handleDeleteBlock}
                    // parameter={parameter?.data || []}
                    // limitOperation={limitOperation}
                    // handleSaveAsDraft={handleSaveAsDraft}
                    />
                </Box>
                <BatchFilterPopup
                    open={filterOpen}
                    onClose={() => setFilterOpen(false)}
                    filterValues={filters}
                    onReset={handleReset}
                    onGenerate={handleGenerate}
                    // data={auditLogs || []}
                    onChange={handleChange}
                    isStatusVisible={false}
                // filterOptions={filterOptions}
                />

                <Box width="100%" className="product-table">
                    {canApproveUop && <> <ConfirmationDialog
                        open={openDailog}
                        title="Confirm Deletion"
                        message="Do you really want to delete this Unit Operation?"
                        onConfirm={handleDelete}
                        onCancel={() => setOpenDailog(false)}
                    />
                    <ConfirmationDialog
                        open={openConfirmDailog}
                        title="Confirm Approval"
                        message="Are you sure you want to approve this Unit Operation?"
                        onConfirm={handleApprove}
                        onCancel={() => setOpenConfirmDailog(false)}
                        text='Approve'
                        loading={rowData?.approving?.loading}
                    /> </>}
                    <Table data={rowData?.uoplist || []} moreOption={canUpdateUop ? ["Update"] : []} handleMenuOption={handleMenuOption} handleApprove={canApproveUop ? handleUopApprove : undefined} />
                    {rowData?.uoplist?.loading && <Loader />}
                    <Pagination
                        count={rowData?.uoplist?.data?.total / rowsPerPage}
                        page={page}
                        onChange={handlePageChange}
                    />
                </Box>
            </InvestigatorContainer>
        </>
    )
}

export default UopList
